<template lang="html">
  <div v-if="overlay" class="inspector">
    <OverlayTextColor v-if="overlay.type == 'text_color'" :overlay="overlay" />
    <ObjectPrint :data="overlay" title="overlay" />
  </div>
</template>

<script>
import find from "lodash/find";
import OverlayTextColor from "./OverlayTextColor";
export default {
  name: "OverlayInspector",
  components: {
    OverlayTextColor
  },
  computed: {
    overlay() {
      var overlayArray =
        (this.$store.state.show.currentShow.data || {}).overlayArray || [];
      return find(overlayArray, { id: this.$store.state.show.activeItem.id });
    }
  },
  methods: {}
};
</script>

<style lang="css" scoped>
.inspector {
  width: 100%;
  height: 100%;
}
</style>
